import { useMemo } from "react";
import { getWiSAEyeReport } from "../../api/config";
import { useFetch } from "../../hooks/useFetch";
import WiFiChannelGraph from "./Graph";
import { useParams } from "react-router-dom";
import styles from "./styles.module.scss";
import Spinner from "../../components/Spinner";
import { WiSAEye } from "../../interfaces/be.interfaces";

const WiSAEyeData = () => {
  const { id } = useParams();
  const { data: response, loading } = useFetch<{ data: WiSAEye[] }>({
    url: getWiSAEyeReport,
    runOnMount: true,
  });

  const rawData = useMemo(() => {
    return response?.data?.find((v) => v.collection_id.toString() === id)?.wisa_eye_raw_data;
  }, [response?.data]);

  // Prepare data for graph and assign random color to it
  const graphData = useMemo(() => {
    return rawData?.map((v) => {
      // Generate a random hex color
      const randomColor =
        "#" +
        Math.floor(Math.random() * 16777215)
          .toString(16)
          .padStart(6, "0");

      return {
        ssid: v.wifi_ssid,
        channelStart: v.channel_start,
        channelEnd: v.channel_end,
        decibel: v.decibel,
        color: randomColor,
      };
    });
  }, [rawData]);

  if (loading) return <Spinner />;

  return (
    <>
      {graphData?.length && (
        <div
          style={{
            width: "100%",
            marginTop: 20,
          }}>
          <WiFiChannelGraph data={graphData} />
        </div>
      )}

      <div
        className={styles.tableResponsive}
        style={{
          marginTop: 20,
        }}>
        {rawData?.length && (
          <table className={styles.table}>
            <thead>
              <tr>
                <th className={styles.center}>WiFi SSID</th>
                <th className={styles.center}>Frequency</th>
                <th className={styles.center}>Channel</th>
                <th className={styles.center}>Decibel</th>
                <th className={styles.center}>Start Channel</th>
                <th className={styles.center}>End Channel</th>
              </tr>
            </thead>
            <tbody>
              {rawData?.map((item) => {
                return (
                  <tr key={item.data_id}>
                    <td className={styles.center}>{item?.wifi_ssid}</td>
                    <td className={styles.center}>{item.frequency}</td>
                    <td className={styles.center}>{item.channel}</td>
                    <td className={styles.center}>{item.decibel}</td>
                    <td className={styles.center}>{item.channel_start}</td>
                    <td className={styles.center}>{item.channel_end}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
};

export default WiSAEyeData;
